import * as React from 'react';
import ReactGA from 'react-ga';
import { Image, FlatList, StyleSheet, Text, View, Dimensions } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import NewButton from '../components/NewButton';
import Header from '../components/Header';
import Tag from '../components/Tag';
import TrendingButton from '../components/TrendingButton';
import { Fonts } from '../utils/Constants';

export default class LandingScreen extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
      campaigns: []
    }
    Dimensions.addEventListener("change", this.handler);
    this.retrieveAllCampaigns();
  }

  handler = (dims) => {
    this.setState({
      width: dims.window.width,
      height: dims.window.height,
    });
  }

  retrieveAllCampaigns = () => {
    fetch('https://fddpufj248.execute-api.us-east-1.amazonaws.com/dev/user/retrieveAllCampaigns')
    .then(response => response.json())
    .then(data => {
      this.setState({campaigns: data});
    });
  }

  componentWillUnmount() {
    // Important to stop updating state after unmount
    Dimensions.removeEventListener("change", this.handler);
  }

  render(){
    let widthCutoff = 1207;
    let styling = {};
    let screenWidth = this.state.width >=1207 ? 1067 : this.state.width;
    if (this.state.width >=widthCutoff){
      styling.width = this.state.width >= 1207 ? 1067 : '75%',
      styling.layout = 'row';
      styling.screenWidth = '100%';
      styling.infoView = {flex: 1, paddingRight: '5%', width: '90%'};
      styling.image = {
        flex: 1,
        height: 400,
        resizeMode: 'contain'
      };
    } else {
      styling.width = this.state.width >= 1067 ? 1067 : '90%';
      styling.layout = 'column';
      styling.screenWidth = '90%';
      styling.infoView = {width: '100%'};
      styling.image = {
        marginTop: '5%',
        height: this.state.width >=650 ? 300 : this.state.width * 0.4,
        width: '80%',
        resizeMode: 'contain'
      };
    }
    //font sizes
    styling.font = this.state.width >= 540 ? {top: 35,mid: 27,low: 20} : {top: 23,mid: 20,low: 15};

    //dimension ratio is 1 (width) by 0.75 (height)
    let cardSize = {width: screenWidth*0.40, height: screenWidth*0.3, numColumns: 2}
    if (screenWidth <= 800 && screenWidth >= 500) {
      cardSize = {width: screenWidth*0.8, height: screenWidth*0.6, numColumns: 1}
    } else if (this.state.width < 500) {
      cardSize = {width: screenWidth*0.9, height: screenWidth*0.68, numColumns: 1}
    }

    return (
      <View style={styles.container}>
        <ScrollView contentContainerStyle={styles.contentContainer}>
          <View
            style={{width: '100%', alignItems: 'center', paddingTop: 10, paddingBottom: 40, backgroundColor: '#6B72A0'}}
            // imageStyle={{ width: '100%', overflow: 'hidden', padding: 20}}
            // source={require('../assets/images/dyp_gradient.svg')}
          >
            <Header color={'white'} navigation={this.props.navigation} width = {styling.width} screenWidth={this.state.width}/>
            <View style={{flexDirection: styling.layout, width: styling.width, alignItems: 'center', justifyContent: 'space-between', marginTop: 40}}>
              <View style={styling.infoView}>
                <Text style={[styles.topBlurbText, {fontSize: styling.font.top}]}>
                <Text style={{fontWeight: 600}}>Take action now on issues that matter.</Text>
                </Text>
                <Text style={[styles.lowerBlurbText, {fontSize: styling.font.mid}]}>
                  #DoYourPart centralizes actionable information for social justice movements and helps increase awareness and impact through shareable images.
                </Text>
                {false && <FlatList
                  data={['texas','product', 'engineering', 'organization']}
                  style={{paddingTop: 20, width: '100%'}}
                  renderItem={({ item, index, separators }) => (
                    <Tag title={item} />
                  )}
                  keyExtractor={item => item}
                  horizontal={true}
                  showsHorizontalScrollIndicator={false}
                />}
              </View>
              <Image
                style={styling.image}
                source={require('../assets/images/globe.svg')}
              />
            </View>
            <BouncyArrow/>
          </View>
          <View style={{marginTop: '5%', flexDirection: 'row', width: styling.width, justifyContent: 'space-between'}}>
            <Text style={{paddingRight: 10, fontFamily: 'Avenir Next', fontWeight: '600', textAlign: 'left', fontSize: styling.font.mid}}>Campaigns to check out</Text>
            <NewButton textColor='black' text='Browse All' borderColor="black" borderWidth={1} width={176} height={45} font='400' action={() => this.props.navigation.navigate('Browse')}/>
          </View>
          <FlatList
            style={{marginTop:40}}
            data={this.state.campaigns}
            numColumns={cardSize.numColumns}
            key={cardSize.numColumns}
            renderItem={({ item }) => (
              <TrendingButton
                source={item.header_image}
                title={item.title}
                description={item.description}
                supporters={item.supporters}
                tags={item.tags}
                width={cardSize.width}
                height={cardSize.height}
                navigate={() => this.props.navigation.push('Campaign', {id: item.unique_id})}
              />
            )}
          />
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    backgroundColor: '#fff',
  },
  contentContainer: {
    alignItems: 'center',
    flexGrow: 1,
    paddingBottom: 20
  },
  welcomeContainer: {
    alignItems: 'center',
    flex: 1,
    marginTop: 10,
    marginBottom: 20,
  },
  header :{
    flexDirection: 'row',
    alignItems: 'center',
    height: 60,
    width: '100%',
    justifyContent: 'center'
  },
  topBlurbText: {
    fontWeight: '400',
    fontSize: 45,
    fontFamily: Fonts.mainFont,
    color: 'white'
  },
  lowerBlurbText: {
    fontFamily: Fonts.mainFont,
    paddingTop: 40,
    color: 'white'
  },
});

const BouncyArrow = (props) => {
  // const moveAnim = useRef(new Animated.Value(0)).current  // Initial value for opacity: 0
  // React.useEffect(() => {
  //   Animated.loop(Animated.timing(
  //     moveAnim,
  //     {
  //       toValue: 1,
  //       easing: Easing.inOut(Easing.elastic(2)),
  //       duration: 3000,
  //       useNativeDriver: false
  //     }
  //  )).start();
  // }, [moveAnim])
  return (
    <Image
      style={{
        ...props.style,
        width:50,
        height:25,
        marginTop: 60,
        marginBottom: 20,
        resizeMode: 'contain',
        // transform: [{
        //   translateY: moveAnim.interpolate({
        //     inputRange: [0, 0.25, 0.5, 1],
        //     outputRange: [25, 0, 0, 25]
        //   }),
        // }],
      }}
      source={require('../assets/images/down_arrow.svg')}
    />
  );
}

